import { GetDocument, GetOffscreenCanvas } from "@pdfking/capability"
import type { ExportImageType, ImageArray } from "@pdfking/compatibility"
import { ContentType } from "@pdfking/structs"

const toImageData = (image: ImageArray): ImageData =>
  new ImageData(new Uint8ClampedArray(image.data), image.width, image.height)

export const ExportImage: ExportImageType = async (image, type = ContentType.WEBP) => {
  const imageData = toImageData(image)

  const Canvas = GetOffscreenCanvas()
  if (Canvas) {
    const canvas = new Canvas(imageData.width, imageData.height)
    const ctx = canvas.getContext("2d")
    if (!ctx) throw new Error("Failed to get canvas 2d context")
    ctx.putImageData(imageData, 0, 0)
    return canvas.convertToBlob({
      type,
    })
  }

  const doc = GetDocument()
  if (doc) {
    const canvas = doc.createElement("canvas")
    canvas.width = imageData.width
    canvas.height = imageData.height
    const ctx = canvas.getContext("2d")
    if (!ctx) throw new Error("Failed to get canvas 2d context")
    ctx.putImageData(imageData, 0, 0)

    return new Promise((resolve, reject) => {
      canvas.toBlob(blob => {
        if (blob) {
          resolve(blob)
        } else {
          reject(new Error("Failed to create blob from canvas"))
        }
      }, type)
    })
  }

  throw new Error("No canvas implementation available")
}
